<template>
    <div class="notifications-list">
        <span class="dropdown-item" v-if="!items.length">
            Aucune notifications.
        </span>
        <div v-for="(noty, index) in items" :key="index" class="dropdown-item d-flex">
            <div class="col-10 border-right">
                <strong>{{ noty.title }}</strong><br>
                <span v-if="noty.link">
                    <a :href="noty.link" target="_blank">
                        {{ noty.desc }}
                    </a>
                </span>
                <span v-else>{{ noty.desc }}</span>
                <div class="small text-muted">{{ noty.elapseTime }}</div>
            </div>
            <div class="col-2 group-button">
                <a href="#" class="custom-btn" @click.prevent="read(noty)" title="Marquer comme lu"><i class="fe fe-check"></i></a>
                <a :href="noty.link" class="custom-btn" target="_blank" title="Télécharger"><i v-if="noty.link" class="fe fe-download"></i></a>
                <a v-if="noty.data.details && noty.data.details.jobId && noty.type == 'App\Notifications\ErrorJob' " href="#" @click.prevent="reloadJob(noty, noty.data.details.jobId)" class="custom-btn" title="Relancer"><i class="fe fe-refresh-cw"></i></a>
            </div>
        </div>
        <template v-if="items.length">
            <div class="dropdown-divider"></div>
            <a href="#" @click.prevent="readAll" class="dropdown-item text-center text-muted-dark">Marquer tous comme lu</a>
        </template>

    </div>
</template>
<script>
export default {
    computed: {
        items() {
            return this.$store.getters['notifications/items'];
        }
    },
    methods: {
        read(noty) {
            this.$store.dispatch('notifications/read', noty);
        },
        readAll(noty) {
            this.$store.dispatch('notifications/readAll');
        },
        reloadJob(noty, jobId) {
            axios.post('/jobs/' + jobId + '/reload').then(() => {
                this.read(noty);
            });
        }
    }
};
</script>
<style lang="scss">
.notifications-list {
    .custom-btn {
        width: 100%;
        display: block;
        text-align: right;
        font-size: 17px;
    }
    .border-right {
        border-right: 1px solid #6c757d;
    }
}
</style>
